import type { RouteObject } from 'react-router';

import { Outlet } from 'react-router';
import { lazy, Suspense } from 'react';

import { getConfig } from 'src/global-config';

import { SplashScreen } from 'src/components/loading-screen/splash-screen';

import { AuthGuard } from 'src/auth/guard/auth-guard';
import { HRAuthGuard } from 'src/auth/guard/hr-guard';

import { usePathname } from '../hooks';

const LayoutEvidenceView = lazy(
  () => import('src/pages/candidate-evidence-view/layout-evidence-view')
);
const CandidateEvidenceViewPage = lazy(() => import('src/pages/candidate-evidence-view'));

function SuspenseOutlet() {
  const pathname = usePathname();
  return (
    <Suspense key={pathname} fallback={<SplashScreen />}>
      <Outlet />
    </Suspense>
  );
}

const evidenceViewLayout = () => (
  <LayoutEvidenceView>
    <SuspenseOutlet />
  </LayoutEvidenceView>
);

export function getCandidateEvidenceViewRoutes(): RouteObject[] {
  const CONFIG = getConfig();

  return [
    {
      path: 'candidate-evidence-view',
      element: CONFIG.auth.skip ? (
        evidenceViewLayout()
      ) : (
        <AuthGuard>
          <HRAuthGuard>{evidenceViewLayout()}</HRAuthGuard>
        </AuthGuard>
      ),
      children: [
        {
          element: <CandidateEvidenceViewPage />,
          index: true,
        },
      ],
    },
  ];
}
